import {LogLevel} from "@azure/msal-browser"

const logThresholdLevel = LogLevel.Warning

export const msalConfig = {
  auth: {
    clientId: process.env.AAD_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.AAD_TENANT_ID}`, // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: process.env.AAD_REDIRECT_URL
  },
  cache: {
    cacheLocation: process.env.AAD_CACHE_LOCATION, // This configures where your cache will be stored
    storeAuthStateInCookie: process.env.AAD_STORE_AUTH_STATE_IN_COOKIE // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    tokenRenewalOffsetSeconds: 2 * 60,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
 
        switch (level) {
          case LogLevel.Verbose:
            console.debug(message)
            break
          case LogLevel.Error:
            console.error(message)
            break
          case LogLevel.Warning:
            console.warn(message)
            break
          case LogLevel.Info:
          default:
            console.info(message)
            break
        }
      },
      logLevel: logThresholdLevel,
      piiLoggingEnabled: false
    }
  }
};
 
// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const scopes = ['User.Read'];

export const loginRequest = {
  scopes
};
 
export const silentRequest = {
  scopes
};
 
export const handleLogin = instance => {
  instance.loginRedirect(loginRequest).catch(e => {
    console.error(e);
  });
};
 
export const handleLogout = (instance, accounts) => {
  const logoutRequest = {
    account: instance.getAccountByHomeId(accounts[0].homeAccountId),
    mainWindowRedirectUri: process.env.AAD_REDIRECT_URL,
    postLogoutRedirectUri: process.env.AAD_REDIRECT_URL
  };
  instance.loginRedirect(logoutRequest).catch(e => {
    console.error(e);
  });
}
